import type { IEvent } from './EventsApi';
import { RestApi } from './base/RestApi';

export interface IEventLocationAddress {
	address_extra: string;
	city: string;
	federal_state: string;
	latitude: number;
	longitude: number;
	postal_code: string;
	street: string;
	street_number: string;
}

export interface IEventLocation {
	address: IEventLocationAddress;
	vpnr: string;
	name: string;
}

export interface IEventSlot {
	canceled_at: string; //"0001-01-01T00:00:00Z",
	ends_at: string; //"2021-12-10T17:30:00Z",
	event: IEvent;
	id: string;
	location: IEventLocation;
	location_count: number;
	location_kind: string | 'ShopLocation';
	non_bookable: boolean;
	participant_count: string;
	participant_limit_hard: string;
	participant_limit_soft: string;
	published_on: string; // "2021-12-01T00:00:00Z",
	registration_deadline: string; // "2021-12-10T16:00:00Z",
	slot_count: number;
	starts_at: string; // "2021-12-10T16:00:00Z"
}

export class EventSlotsApi extends RestApi<IEventSlot> {
	constructor(path = '/slots') {
		super(path);
	}
}
